module.exports = __webpack_public_path__ + "static/media/StripedHorseResources_Logo2000x2000.26393919.png";